export default __webpack_public_path__ + "static/media/compas_user_revoke.7290ae92.gif";